import axios from "axios";
import {  ADMIN_BASE_URL} from "./endpoints";
import { getToken } from "../utils/authHelper";
const adminAxiosInstance = axios.create({
  baseURL: ADMIN_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const adminAxiosFormInstance = axios.create({
  baseURL: ADMIN_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
adminAxiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
adminAxiosFormInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default adminAxiosInstance;